import { Component } from '@angular/core';
import { IonicPage } from 'ionic-angular';
import { environment } from "../../environments/environment";
import { DomSanitizer } from "@angular/platform-browser";

@IonicPage({
  name: 'api-docs',
  segment: 'api-docs'
})
@Component({
  selector: 'page-api-docs',
  templateUrl: 'api-docs.html',
})

export class APIDocsPage {
  private swaggerURL;
  constructor(
    private domSanitizer: DomSanitizer) {
    const envURL = environment.BASE_URL.split('"').pop().split('/f').shift();
    this.swaggerURL = this.domSanitizer.bypassSecurityTrustResourceUrl(envURL + '/api-docs/');


  }

}



// WEBPACK FOOTER //
// ./src/pages/api-docs/api-docs.ts